import ToolPage from 'components/ToolPage';
import { toolAPI } from 'utils/api';
export default function JpgToPng() {
  return <ToolPage
    seoTitle="JPG to PNG Converter Free"
    seoDesc="Convert JPG images to PNG online, free. Keeps transparency support. No signup."
    path="/tools/image/jpg-to-png"
    seoKey="jpg-to-png"
    iconName="convert" title="JPG to PNG" desc="Convert JPG or JPEG images to lossless PNG format with transparency support." accept="image/jpeg,image/jpg,image/*" hint="Supported: JPG, JPEG · Max 20MB" buttonLabel="Convert to PNG" apiCall={toolAPI.jpgToPng} outputFilename="converted.png" infoText="PNG is a lossless format — no quality loss during conversion. PNG supports transparent backgrounds." />;
}
